module.exports = __webpack_public_path__ + "fonts/Golos-Text_DemiBold.43525ca.woff2";